"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
class HealingBuilder {
    constructor(healing) {
        this.healing = healing;
    }
    end() {
        return this.healing;
    }
    param(...params) {
        this.healing.params.push(...params);
        return this;
    }
    limit(limit) {
        this.healing.limit = limit;
        return this;
    }
    base(base) {
        this.healing.base = base;
        return this;
    }
    rate(n) {
        this.healing.rate = n;
        return this;
    }
    shouldComputeCri(isAdd = true) {
        if (!isAdd)
            return this;
        this.healing.params.push(index_1.HealingParams.SHOULD_COMPUTE_CRI);
        return this;
    }
}
exports.HealingBuilder = HealingBuilder;
class Healing {
    constructor(sourceId, targetId) {
        this.base = index_1.BattleProperties.MAX_HP; // 基础数值来源
        this.rate = 0; // 倍率
        this.params = [];
        this.sourceId = sourceId;
        this.targetId = targetId;
    }
    hasParam(p) {
        return this.params.includes(p);
    }
    addParam(p) {
        this.params.push(p);
    }
    static build(sourceId, targetId) {
        return new HealingBuilder(new Healing(sourceId, targetId));
    }
}
exports.default = Healing;
